import { render, staticRenderFns } from "./OrderHistoryCard.vue?vue&type=template&id=3597db80&scoped=true&"
import script from "./OrderHistoryCard.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryCard.vue?vue&type=script&lang=js&"
import style0 from "./OrderHistoryCard.vue?vue&type=style&index=0&id=3597db80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3597db80",
  null
  
)

export default component.exports
import QItem from 'quasar/src/components/item/QItem.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QItem,QInnerLoading,QItemSection,QItemLabel,QIcon,QBtn});
